import { ChevronLeft } from "@mui/icons-material";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";
import { Navigate, useNavigate } from "react-router";

const PageHeader = ({
  title,
  showBack,
  buttonTitle,
  buttonOnClick,
  rightComponent = null,
  textAlignedCenter = false,
  lead
}) => {
  const navigate = useNavigate();
  return (
    <Box display="flex" alignItems="center" gap={2} mb={4} sx={{
      textAlign : textAlignedCenter ? 'center' : 'inherit'
    }} >
      {showBack && (
        <IconButton onClick={() => navigate(-1)}>
          <ChevronLeft />
        </IconButton>
      )}
      <Stack flex={1} >

      <Typography variant="h6" fontWeight={500}  >{title}</Typography>
      {lead && <Typography variant="body2" color={grey[600]} fontWeight={500}  >{lead}</Typography>}
      </Stack>

      {buttonTitle && (
        <Button variant="outlined" sx={{ ml: "auto" }} onClick={buttonOnClick}>
          {buttonTitle}
        </Button>
      )}
      {rightComponent && <Box ml="auto">{rightComponent}</Box>}
    </Box>
  );
};

export default PageHeader;
